/**
 * @deprecated 未來遊戲不再支援 v1 的 toggles，請改用 `FeatureToggleV2Type`。
 */
export enum FeatureToggleType {
  disableCurrencyDisplay = 'disableCurrencyDisplay',
  disableLeaveGameBtn = 'disableLeaveGameBtn',
  disableLeaveGameBtnByRedirectUrlNotExisted = 'disableLeaveGameBtnByRedirectUrlNotExisted',
  disableRTPDisplay = 'disableRTPDisplay',
  disableFunkyGameLogo = 'disableFunkyGameLogo',
  disableHistoryList = 'disableHistoryList',
  disableChangePose = 'disableChangePose',
  disableTutorial = 'disableTutorial',
  disableBuyBonus = 'disableBuyBonus',
  enableRetryGetBalance = 'enableRetryGetBalance',
  disableVideoRecording = 'disableVideoRecording',
  displayRefNoWhenPlacedOrder = 'displayRefNoWhenPlacedOrder',
  enablePlaceOrderInterval = 'enablePlaceOrderInterval',
  enableSessionWinLose = 'enableSessionWinLose',
  enableSessionTime = 'enableSessionTime',
  enableSessionTotalStake = 'enableSessionTotalStake',
  enableSessionTotalWin = 'enableSessionTotalWin',
  disableAutoPlay = 'disableAutoPlay',
  disableTurboMode = 'disableTurboMode',
  enableReplaySlotOningGame = 'enableReplaySlotOningGame',
  enableSkpSlotOngoingGame = 'enableSkpSlotOngoingGame',
  disableReelTableClickForSpin = 'disableReelTableClickForSpin',
  disableSlamStop = 'disableSlamStop',
  disableSpacebarSpin = 'disableSpacebarSpin',
}

export enum FeatureToggleV2Type {
  displayCurrency = 'displayCurrency',
  displayRefNo = 'displayRefNo',
  displaySessionWinLose = 'displaySessionWinLose',
  displayRTPGameInfo = 'displayRTPGameInfo',
  displayVoucherGameInfo = 'displayVoucherGameInfo',
  enableBuyBonus = 'enableBuyBonus',
  enableTurbo = 'enableTurbo',
  enableAutoPlay = 'enableAutoPlay',
  enableBackBtn = 'enableBackBtn',
  enableBackButtonForRedirectUrl = 'enableBackButtonForRedirectUrl',
  enableBetHistory = 'enableBetHistory',
  displayLogo = 'displayLogo',
  useNumberKMFormat = 'useNumberKMFormat',
  enableVideoRecord = 'enableVideoRecord',
  enableChangePose = 'enableChangePose',
  enableBetCooldown = 'enableBetCooldown',
  enableSessionTime = 'enableSessionTime',
  enableSessionTotalStake = 'enableSessionTotalStake',
  enableSessionTotalWin = 'enableSessionTotalWin',
  enableSkipOngoingReplay = 'enableSkipOngoingReplay',
  enableSlamStop = 'enableSlamStop',
  enableSpacebarSpin = 'enableSpacebarSpin',
  enableReelTableClickForSpin = 'enableReelTableClickForSpin',
}
